import { render, staticRenderFns } from "./Identity-Information.vue?vue&type=template&id=72143493"
import script from "./Identity-Information.vue?vue&type=script&lang=js"
export * from "./Identity-Information.vue?vue&type=script&lang=js"
import style0 from "./Identity-Information.vue?vue&type=style&index=0&id=72143493&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports